import React from 'react'
import './App.css';
import './Reservas.css';
import './loader.css';
import Encabezado from './Encabezado';
import Mapas from './Mapas';
import Reserva from './Consulta-Reserva';
import TyC from './TyC';
import InfoCancha from './InfoCancha';
import ReservaCreada from './ReservaCreada';
import PaymentTest from './PaymentTesting';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';

function App() {

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <header className="App-header">
            <Encabezado/>
          </header>
          <Routes>
            <Route path='/' element = {<Mapas/>}/>
            <Route path='/Cancha' element = {<InfoCancha/>}/>
            <Route path='/Cancha/:slug' element = {<InfoCancha/>}/>
            <Route path='/terminos-y-condiciones' element = {<TyC/>}/>
            <Route path='/consulta-tu-reserva' element = {<Reserva/>}/>
            <Route path='/Reserva-creada' element = {<ReservaCreada/>}/>
            <Route path='/Test' element = {<PaymentTest/>}/>
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
    
}



export default App;
